import products from '@/api/productsList';
import { validationMixin } from 'vuelidate';
import { required, requiredIf, maxLength} from 'vuelidate/lib/validators';

export default {

    mixins: [validationMixin],

    validations: {
        selectedProduct: { required },
    },
    props: {
        label       :  {
            type    : String,
            default : ""
        },
        hint       :  {
            type    : String,
            default : ""
        },
        required       :  {
            type    : Boolean,
            default : false
        },
        disabled       :  {
            type    : Boolean,
            default : false
        },
    },
    data () {
        return {
            //for testing purposes
            //list of products to be selected into autocomplete component
            productsList            : products,
            selectedProduct         : null,
            isUpdating              : false,
        };
    },
    methods: {
        onSelectProduct() {
            console.info('onSelectProduct', this.selectedProduct);
            this.$emit('change-selected-product', this.selectedProduct);
        },
        onClearSelectedProduct() {
            console.info('clear product event');
            this.selectedProduct = [];
            this.$emit('clear-selected-product');
            this.$v.selectedProduct.$reset();
        },
       validate() {
            this.$v.selectedProduct.$touch();
            if(!this.$v.selectedProduct.$dirty) {
                return false;
            } else {
                this.$v.selectedProduct.$touch();
                if (!this.$v.selectedProduct.$anyError) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        getSelectedProductInfos() {
            if (!this.selectedProduct) {
                return;
            }
            return this.selectedProduct;
        },
        remove (item) {
            ndex = this.selectedProduct.indexOf(item.name);
            if (index >= 0) this.selectedProduct.splice(index, 1);
        },
    },
    watch: {
        // '$v.selectedProduct.$anyError' : function(errors) {
        //     if (errors) {
        //         // Fire when the form is cleared
        //         // @arg The argument is a boolean value representing xxx
        //         this.$emit('step-product-data-has-errors');
        //     } else {
        //         // Fire when the form is cleared
        //         // @arg The argument is a boolean value representing
        //         this.$emit('step-product-data-is-valid');
        //
        //     }
        // },
        // '$v.stepProductData.$dirty' : function(dirty) {
        //     if (!dirty && !this.$v.stepProductData.$anyError) {
        //         // Fire when the form is cleared
        //         // @arg The argument is a boolean value representing
        //         this.$emit('step-product-data-is-valid');
        //     } else {
        //         if (this.$v.stepProductData.$anyError) {
        //             // Fire when the form is cleared
        //             // @arg The argument is a boolean value representing xxx
        //             this.$emit('step-product-data-has-errors');
        //         }
        //     }
        // }
    },
    computed: {
        //push errors for if case
        selectedProductErrors () {
            const errors = [];
            if (!this.$v.selectedProduct.$dirty) {
                return errors;
            }
            if (!this.$v.selectedProduct.required) {
                errors.push('selectedProduct is required');
            }
            return errors;
        },
    }
};
